import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getLangFromPath, stripLang } from '../i18n/langs';
import { SERVICE_CONTENT, FAQ_TITLE } from '../data/serviceContent';

/** Texto de apoyo + preguntas frecuentes (con datos estructurados FAQPage) de la página actual. */
const ServiceContent: React.FC = () => {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const page = SERVICE_CONTENT[stripLang(location.pathname)]?.[lang];
  if (!page) return null;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: page.faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section className="py-12 bg-gray-50 border-t border-gray-100">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <div className="container mx-auto px-4 max-w-4xl">
        {page.title && page.intro && (
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-6">{page.title}</h2>
            {page.intro.map((p, i) => (
              <p key={i} className="text-gray-700 text-lg leading-relaxed mb-4">{p}</p>
            ))}
          </div>
        )}
        <h2 className="text-3xl font-bold mb-6">{FAQ_TITLE[lang]}</h2>
        <div className="space-y-3">
          {page.faqs.map((f, i) => (
            <details key={i} className="bg-white rounded-lg p-5 shadow-sm" open={i === 0}>
              <summary className="font-semibold text-lg cursor-pointer">{f.q}</summary>
              <p className="mt-3 text-gray-700 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceContent;
